import { ApiProperty } from "@nestjs/swagger";

export class StockInPrintRequest{
    @ApiProperty()
    reportingLogId:number;
}